import {React} from 'external/react'
import {useTheme, makeStyles, Box} from 'external/material'
import Pagination from './pagination'

const verticalCentering = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    color: '#4f576e',
    fontSize: '12pt',
  },
  count: {
    display: 'flex',
  },
  countIcon: {
    ...verticalCentering,
    marginTop: -5,
    marginRight: 5
  },
  questionsLabel: {...verticalCentering},
  countLabel: {...verticalCentering},
  pagination: {
    flexGrow: 1
  }
}))

export default function Footer ({context}) {

  const {tab} = context
  const classes = useStyles()
  const page = parseInt(context.query.page)
  const {recordCount, pageSize} = context.quizPaging
  const pageCount = Math.ceil(recordCount / pageSize)

  return (
    <Box className={classes.root}>
      <Box className={classes.count}>
        <Box className={classes.questionsLabel}>{context.translate('question-bank-pagination-label')}</Box>
        <Box className={classes.countLabel}>: {recordCount}</Box>
      </Box>
      {pageCount > 1 && (
        <Box className={classes.pagination}>
          <Pagination context={context} page={isNaN(page) ? 1 : page} count={pageCount} />
        </Box>
      )}
    </Box>
  )
}

